import Cookies from 'js-cookie'
import * as types from '../mutation-types'

// state
export const state = {
  playSound: Cookies.get('sound') == "true"
}

// getters
export const getters = {
  playSound: state => state.playSound,
}

// mutations
export const mutations = {
  [types.PLAY_SOUND] (state, { playSound }) {
    state.playSound = playSound
    Cookies.set('sound', playSound, { expires: 365 })
  }
}

// actions
export const actions = {
  setSound ({ commit, dispatch }, payload) {
    commit(types.PLAY_SOUND, payload)
  }
}
